import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1310;
`;

export const ModalContainer = styled.div`
  background: white;
  padding: 32px;
  border-radius: 10px;
  width: 830px;
  max-width: calc(100vw - 32px);
  box-sizing: border-box;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  overflow: visible;
  position: relative;
  z-index: 1;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 5px 16px;
`;

export const HeaderContent = styled.div`
  flex: 1;
  min-width: 0;

  h1,
  h2,
  h3 {
    margin: 0;
    line-height: 1.25;
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.tokens.color.text.secondary};

  &:hover {
    color: ${({ theme }) => theme.tokens.color.text.primary};
  }

  &:focus {
    outline: 2px solid ${({ theme }) => theme.tokens.color.interaction.softDefault};
    outline-offset: 2px;
    border-radius: 4px;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
  }
`;

export const ModalBody = styled.div`
  padding: 16px;
  color: ${({ theme }) => theme.tokens.color.text.secondary};
  line-height: 1.5;
  overflow: visible;
`;

export const FormGroup = styled.div`
  margin-top: 1.5rem;
  width: 100%;
`;

export const SelectFieldBlock = styled.div`
  width: 370px;
  max-width: 100%;
  box-sizing: border-box;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  padding: 16px;
`;
